module.exports = __webpack_public_path__ + "static/media/marcus.e7ef1e1c.png";